import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { flow } from 'lodash-es';
import qs from 'query-string';
import getOr from 'lodash/fp/getOr';
import zhHant from './zhHant';
import en from './en';
import zhCn from './zhCn';
import vi from './vi';
import th from './th';
import ja from './ja';

export const DEFAULT_LANG = 'en';

const parseLocale = flow(qs.parse, getOr(DEFAULT_LANG, 'locale'));

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  resources: {
    'zh-hant': zhHant,
    'zh-cn': zhCn,
    vi,
    th,
    en,
    ja,
  },
  lowerCaseLng: true,
  fallbackLng: DEFAULT_LANG,
  lng: parseLocale(window.location.search),
  interpolation: {
    escapeValue: false,
  },
  initImmediate: false,
});

export default i18n;
